export default "__VITE_ASSET__D9uM9xPd__"